import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";
import Switch from "react-switch";

class BecaSalud extends Component {
    state = {
        chkSi: this.props.datos.chkSi.value,
        chkNo: this.props.datos.chkNo.value,
        chkFis: this.props.datos.chkFis.value,
        chkPsi: this.props.datos.chkPsi.value,
        chkSen: this.props.datos.chkSen.value,
        enfermedad: this.props.datos.enfermedad.text,
        enDis: this.props.datos.enDis.value,
        discapacidad: this.props.datos.discapacidad.text,
        diDis: this.props.datos.diDis.value,
    }

    cambiaSwitch = () => {
        let campoSi = { value: !this.state.chkSi, errMess: "" }
        let campoNo = { value: !this.state.chkNo, errMess: "" }
        let campoSt = { value: this.state.chkSi, errMess: "" }
        let campoTxt = { text: "", errMess: "" }

        if (this.state.enDis === false){
            campoTxt = { text: "", errMess: "" } 
        }else{
            campoTxt = { text: this.state.enfermedad, errMess: "Debes especificar el tipo de enfermedad" }
        }

        this.setState({
            chkSi: !this.state.chkSi,
            chkNo: !this.state.chkNo,
            enDis: this.state.chkSi,
            enfermedad: campoTxt.text
        }, () => {
            this.props.funcion("chkSi", campoSi, "datosBecaSalud")
            this.props.funcion("chkNo", campoNo, "datosBecaSalud")
            this.props.funcion("enDis", campoSt, "datosBecaSalud")
            this.props.funcion("enfermedad", campoTxt, "datosBecaSalud")
        })
    }

    cambiaValorE = (prop) => (e) => {
        let campoTxt = { text: "", errMess: "" }

        if (this.state.enDis === true){
            campoTxt = { text: "", errMess: "" } 
        }else{
            campoTxt = { text: e.target.value, errMess: "Debes especificar el tipo de enfermedad" }
        }
        
        this.props.funcion(prop, campoTxt, "datosBecaSalud")
    }

    cambiaValorD = (prop) => (e) => {
        let campoTxt = { text: "", errMess: "" }
        if (this.state.chkFis === false && this.state.chkPsi === false && this.state.chkSen === false){
            campoTxt = { text: "", errMess: "" }
        }else{
            campoTxt = { text: this.state.discapacidad, errMess: "Debes especificar el porcentaje (%)  de discapacidad" }
        }
        this.props.funcion(prop, campoTxt, "datosBecaSalud")
    }

    cambiaState = (prop) => (e) => {
        this.setState({
            [prop]: (e.target.value).toUpperCase()
        })
    }

    cambiaSwitchSalud = (tipo) => () => {
        let campoTxt = { text: "", errMess: "" }
        let dis = false;
        let funciones = () => {
            let campochkFis = { value: false, errMess: "" }
            let campochkPsi = { value: false, errMess: "" }
            let campochkSen = { value: false, errMess: "" }

            switch (tipo) {
                case "chkFis":
                    campochkFis = { value: this.state.chkFis, errMess: "" }
                    break
                case "chkPsi":
                    campochkPsi = { value: this.state.chkPsi, errMess: "" }
                    break
                case "chkSen":
                    campochkSen = { value: this.state.chkSen, errMess: "" }
                    break
            }

            this.props.funcion("chkFis", campochkFis, "datosBecaSalud")
            this.props.funcion("chkPsi", campochkPsi, "datosBecaSalud")
            this.props.funcion("chkSen", campochkSen, "datosBecaSalud")
            this.props.funcion("discapacidad", campoTxt, "datosBecaSalud")
        }

        this.setState({
            chkFis: false,
            chkPsi: false,
            chkSen: false,
            [tipo]: !this.state[tipo],
            
        }, () => {
            if (this.state.chkFis === false && this.state.chkPsi === false && this.state.chkSen === false){
                campoTxt = { text: "", errMess: "" }
                dis = false
            }else{
                campoTxt = { text: this.state.discapacidad, errMess: "Debes especificar el porcentaje (%)  de discapacidad" }
            }

            this.setState({
                discapacidad: campoTxt.text,
                diDis: dis,
            }, () => { funciones() })
        })
    }

    render() {
        let { chkSi, chkNo, chkFis, chkPsi, chkSen, enDis, enfermedad, discapacidad, diDis } = this.state;

        return (
            <React.Fragment>
                <div className="custom-alert-info custom-mt-10">Situación de Salud</div>
                <Row>
                    <Col md={12} className="custom-mt-10">
                        <div className="text-muted">Indica si padeces alguna enfermedad</div>
                        <Row>
                            <Col md={3} align="center" style={{paddingTop: 10}}>
                                <Switch height={12} width={24} onChange={this.cambiaSwitch} checked={chkSi} /> Si
                            </Col>
                            <Col md={3} align="center" style={{paddingTop: 10}}>
                                <Switch height={12} width={24} onChange={this.cambiaSwitch} checked={chkNo} /> No
                            </Col>
                            <Col md={6}>
                                <input type="text" onBlur={this.cambiaValorE("enfermedad")} onChange={this.cambiaState("enfermedad")} value={enfermedad} disabled={enDis} className="form-control" placeholder="Especifica en caso de padecer"/>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={12} className="custom-mt-10">
                        <div className="text-muted">En caso de discapacidad, indica el tipo</div>
                        <Row>
                            <Col md={3} align="center" style={{paddingTop: 10}}>
                                <Switch height={12} width={24} onChange={this.cambiaSwitchSalud("chkFis")} checked={chkFis} /> Física
                            </Col>
                            <Col md={3} align="center" style={{paddingTop: 10}}>
                                <Switch height={12} width={24} onChange={this.cambiaSwitchSalud("chkPsi")} checked={chkPsi} /> Psiquica
                            </Col>
                            <Col md={3} align="center" style={{paddingTop: 10}}>
                                <Switch height={12} width={24} onChange={this.cambiaSwitchSalud("chkSen")} checked={chkSen} /> Sensorial
                            </Col>
                            <Col md={3} align="center">
                                <input type="text" onBlur={this.cambiaValorD("discapacidad")} onChange={this.cambiaState("discapacidad")} value={discapacidad} disabled={diDis} className="form-control" placeholder="% de Discapacidad" title="Indica el % de Discapacidad en caso de poseer"/>
                                <span className="text-muted" style={{fontSize:10}}>% de Discapacidad</span>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}
 
export default BecaSalud;


// WEBPACK FOOTER //
// ./src/views/EstSolicitudes/BecaSalud.jsx